// eslint-disable-next-line import-x/no-extraneous-dependencies -- pre-existing violation
import { ProductEvent } from "@classdojo/log-client/lib/client/client";

export type LogEventFunction = (event: string | ProductEvent) => Promise<unknown> | undefined;

let logEvent: LogEventFunction = function () {
  throw new Error("You must initialize the component library with a `logEvent` function to log events!");
};

export function sendLogEvent(event: string | ProductEvent): Promise<unknown> | undefined {
  return logEvent(event);
}

export function setLogEventFunction(fn: LogEventFunction): void {
  logEvent = fn;
}
